import { Color, Radius, Spacing } from 'zens-storybook'
import React, { Suspense, useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ApiError, Draft, LocationData, useLocationMutation, useStore } from 'zens-store'
import { useRouter, useNumberParams } from 'zens-router'
import { CompanyHeader, LayoutHeader, LocationForm } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
    padding: Spacing.L,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
  },
})

const LocationAdd = () => {
  const [errors, setErrors] = useState<Record<string, string>>()
  const router = useRouter()
  const store = useStore()
  const { message } = store
  const [{ companyId }] = useNumberParams()
  const mutation = useLocationMutation({ companyId })
  const { t } = useTranslation()

  const add = async (draft: Draft<LocationData>) => {
    try {
      setErrors({})
      await mutation.create(draft)
      message.add({
        message: t('Location was created successfully'),
        status: 'success',
      })
    } catch (error) {
      const { message: errorMessage, fields } = error as ApiError
      if (fields) {
        setErrors(fields)
      } else {
        message.add({
          message: `${t('Location could not be created')}. ${errorMessage}`,
          status: 'error',
        })
      }
      return
    }

    router.push(`/companies/${companyId}/detail`)
  }

  return (
    <View style={styles.container}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <CompanyHeader companyId={companyId} breadcrumbItems={[{ title: t('Add location') }]} />
      </Suspense>
      <View style={styles.content}>
        <Suspense fallback={<LocationForm.Skeleton />}>
          <LocationForm
            companyId={companyId}
            onSave={add}
            cancelHref={`/companies/${companyId}/detail`}
            errors={errors}
          />
        </Suspense>
      </View>
    </View>
  )
}

export default LocationAdd
